<template>

  <div ref="headerContent"
  class="header-content"
  :class="{ 'homepage-header-content': pageType.homePage, 'video-content': hero.post.acf.header_type == 'Video'  }"
  v-if="pageType.homePage || pageType.landingPage">

    <div class="hero-image-container">
      <template v-if="(hero.post.acf.header_type == 'Image') || pageType.landingPage">
        <div class="hero-image"
        :style="{ backgroundImage: `url(${hero.post.acf.hero_image.url}` }"
        :key="hero.post.acf.hero_image.url"
        alt="Hero Image"
        ref="blah">
        </div>
      </template>

      <div v-if="hero.post.acf.header_type == 'Video'">
        <div class ="videowrapper">
          <video loop muted autoplay playsinline ref="videoSource">{{videoScript()}}</video>
        </div>
      </div>
    </div>

    <div class="page-title-container hero-image-with-title" v-if="pageType.landingPage">
      <div class="page-title-container-inner">
        <h1 class="landing-page-title" v-html="pageContent.title"></h1>
      </div>
    </div>

    <div class="ms-grid home-page-news-intro-position">
      <article class="home-page-news-intro" role="article" v-if="hero.availableNews && (hero.post.acf.intro_type == 34)">
        <a class="home-page-news-intro-anchor" :href="hero.post.acf.link_url">
          <h1 class="home-page-news-intro-headline" v-html="hero.post.acf.headline"></h1>
          <p class="home-page-news-intro-text">{{hero.post.acf.link_text}} <strong>More</strong>
            <ArrowSVG/>
          </p>
        </a>
      </article>
    </div>
  </div>

</template>

<script>

import ArrowSVG from '@/components/ui-components/svg/icon-arrow.svg';

export default {
  name: 'HeaderHero',
  props: ['hero', 'pageType', 'pageContent'],
  components: {
    ArrowSVG,
  },
  methods: {
    videoScript() {
      this.$nextTick(() => {
        const vid = `${this.hero.post.acf.youtube_video_id}`;
        let streams;
        const videoTag = this.$refs.videoSource;
        fetch(`https://images${~~(Math.random() * 33)}-focus-opensocial.googleusercontent.com/gadgets/proxy?container=none&url=https%3A%2F%2Fwww.youtube.com%2Fget_video_info%3Fvideo_id%3D${vid}`).then((response) => response.text()).then((data) => {
          if (data) {
            streams = parse_youtube_meta(data);
            videoTag.src = streams['1080p'] || streams['720p'] || streams['360p'];
          } else {
            alert('Youtube API Error');
          }
        });
        function parse_youtube_meta(rawdata) {
          const data = parse_str(rawdata);
          const player_response = JSON.parse(data.player_response);
          let streams = [];
          const result = {};
          data.player_response = player_response;
          if (data.hasOwnProperty('adaptive_fmts')) {
            streams = streams.concat(data.adaptive_fmts.split(',').map((s) => parse_str(s)));
          } else if (player_response.streamingData && player_response.streamingData.adaptiveFormats) {
            streams = streams.concat(player_response.streamingData.adaptiveFormats);
          }
          if (data.hasOwnProperty('url_encoded_fmt_stream_map')) {
            streams = streams.concat(data.url_encoded_fmt_stream_map.split(',').map((s) => parse_str(s)));
          } else if (player_response.streamingData && player_response.streamingData.formats) {
            streams = streams.concat(player_response.streamingData.formats);
          }
          streams.forEach((stream, n) => {
            const itag = stream.itag * 1;
            const quality = false;
            const itag_map = {
              18: '360p',
              22: '720p',
              37: '1080p',
              38: '3072p',
              82: '360p3d',
              83: '480p3d',
              84: '720p3d',
              85: '1080p3d',
              133: '240pna',
              134: '360pna',
              135: '480pna',
              136: '720pna',
              137: '1080pna',
              264: '1440pna',
              298: '720p60',
              299: '1080p60na',
              160: '144pna',
              139: '48kbps',
              140: '128kbps',
              141: '256kbps',
            };
            // if (stream.type.indexOf('o/mp4') > 0) console.log(stream);
            if (itag_map[itag]) result[itag_map[itag]] = stream.url;
          });
          return result;
        }
        function parse_str(str) {
          return str.split('&').reduce((params, param) => {
            const paramSplit = param.split('=').map((value) => decodeURIComponent(value.replace('+', ' ')));
            params[paramSplit[0]] = paramSplit[1];
            return params;
          }, {});
        }
      });
    },
  },
};

</script>

<style scoped lang="scss">

.header-content {
  margin: 0 auto;
  max-width: $siteMaxWidth;
  position: relative;
}
.video-content {
  max-width: none;
}

.page-title-container {
  left: 0px;
  top: 0px;
  position: absolute;
  width: 100%;

  @media (min-width: $vp4) {
    height: 100%;
  }
  .page-title-container-inner {
    height: 100%;
    @include centerfy();
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: flex-end;

    @media (min-width: $vp3) and (max-width: $vp4) {
      height: 600px;
    }

    @media (min-width: $vp2) and (max-width: $vp3) {
      height: 455px;
    }

    @media (max-width: $vp2) {
      height: 250px;
    }
  }
  .header-brand-mark {
    bottom: 0px;
    height: $mobileHeaderHeight;
    padding: 20px;
    position: absolute;
    width: 100%;

    @media (min-width: $vp3) {
      bottom: 30px;
      height: auto;
      left: 30px;
      right: 30px;
      top: 30px;
      padding: 0px;
    }

    @media (min-width: $vp4) {
      position: static;
      width: 100%;
    }
  }
}

.hero-image-container {
  overflow: hidden;
}
.hero-image {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: block;
  left: 50%;
  margin: 0 auto;
  position: relative;
  transform: translateX(-50%);
  width: auto;
  @include headerHeights();
}
.scrolled-before .hero-image {
  @media (min-width: $siteMaxWidth) {
    left: 0px;
    transform: none;
  }
}

// Home Page News Intro
.home-page-news-intro-position {
  @media(max-width: $vp3) {
    position: absolute;
    top: 0;
    bottom: 0;
  }
  .home-page-news-intro {
    background: $blue;
    color: #FFF;
    min-height: 170px;
    padding: 20px 30px 30px;
    bottom: 24px;
    position: absolute;
    background: rgba(0, 0, 0, 0.5);
    max-width: 60%;
    @media (max-width: $vp4) {
      margin: unset;
      right: unset;
    }
    @media (max-width: $vp3) {
      min-height: unset;
      bottom: 0;
    }
    @media (max-width: $vp2) {
      padding: 10px 20px 20px;
    }
    .home-page-news-intro-anchor {
      color: #FFF;
      display: block;
      margin: 0 auto;
      max-width: $siteContentWidth;
      text-decoration: none;
      &:hover,
      &:visited {
        color: #FFF;
        text-decoration: none;
        .arrow {
          @include arrowActiveState();
        }
      }
    }
    .home-page-news-intro-headline {
      font-size: 110px;
      font-weight: 600;
      line-height: 1;
      @media (min-width: $vp3) and (max-width: $vp4) {
        font-size: 100px;
      }
      @media (max-width: $vp3 - 1px) {
        font-size: 72px;
      }
      @media (max-width: $vp2 + 100) {
        font-size: 32px;
      }
      @media (max-width: $vp2) {
        font-size: 28px;
      }
    }
    .home-page-news-intro-text {
      font-size: 32px;
      line-height: 1;
      @media (min-width: $vp3) and (max-width: $vp4) {
        font-size: 24px;
      }
      @media (max-width: $vp3 - 1px) {
        font-size: 18px;
      }
      @media (max-width: $vp2) {
        font-size: 14px;
      }
      .arrow {
        fill: #FFF;
        height: 10px;
        width: 10px;
        @include arrowTransition();
      }
    }
  }
}

// Landing Page Header

.page-title-container.hero-image-with-title {
  .landing-page-title {
    line-height: 92.5%;
    max-width: 60%;
    background-color: rgb(0,0,0,0.5);
    padding: 30px;
    word-wrap: normal;

    @media (max-width: $vp4) {
      line-height: 1.2;
      padding: 0 20px;
      width: 100%;
    }

    @media (min-width: $vp3) and (max-width: $vp4) {
      font-size: 100px;
    }

    @media (max-width: $vp3 - 1px) {
      font-size: 72px;
    }

    @media (max-width: $vp2) {
      font-size: 40px;
    }
  }
}

video {
  /*  object-fit: cover; */
  width: 100%;
  height: 100%;
  transform: rotateZ(0);
}
.videowrapper {
  width: 100%;
  margin-bottom: -3.5%;
  margin-top: -3.5%;
  background: #FFFFFF;
}

</style>
